import {
  buildHandinAssignmentURL,
  buildHandinSubmissionURL,
} from '$utils/buildHandinURLs';
import buildQuizURL from '$utils/buildQuizURL';
import { providers } from '$variables/constants';

const getExternalLinkProperties = ({
  space,
  externalId,
  id,
  provider,
  studentGrade,
  isEducator,
  launchTurnitinAssignment,
  launchTurnitinSubmission,
  submission,
  endDate,
}) => {
  const isHandin = provider === providers.HAND_IN;
  const isTIIAssignment = provider === providers.TURNITIN;
  const isQuiz = provider === providers.QUIZZES;

  if (isQuiz) {
    // if a student has submitted the quiz and the quiz end date/time has not elapsed
    // do not allow the student to access the link yet
    if (
      !isEducator &&
      submission &&
      submission.length &&
      new Date() < new Date(endDate)
    ) {
      return { onClick: () => {} };
    }
    const quizURL = buildQuizURL({
      spaceId: space,
      isEducator,
      submission,
      id,
    });

    return {
      to: quizURL,
    };
  }

  // For an educator, accessing the assignments page
  // launch TII assignment
  if (isTIIAssignment && isEducator && !studentGrade) {
    return {
      onClick: () => launchTurnitinAssignment(id),
    };
  }

  // For an educator, accessing student page, launch TII submission
  if (
    isTIIAssignment &&
    isEducator &&
    studentGrade &&
    studentGrade.externalId
  ) {
    return {
      onClick: () => launchTurnitinSubmission(studentGrade.externalId),
    };
  }

  // For a student, always launch TII assignment
  if (isTIIAssignment && !isEducator) {
    return {
      onClick: () => launchTurnitinAssignment(id),
    };
  }

  // student can't access submission page in Handin
  if (isHandin && (!studentGrade || !isEducator)) {
    return {
      to: buildHandinAssignmentURL({ space, externalId }),
    };
  }

  if (isHandin) {
    return {
      to: buildHandinSubmissionURL({
        space,
        externalId,
        studentId: studentGrade.studentId,
      }),
    };
  }

  return {};
};

export default getExternalLinkProperties;
